import { Auth } from "firebase/auth";
import { getStorage, ref, uploadString, getDownloadURL } from "firebase/storage";
import axios from "axios";
import app from "../../../firebase";

const setOrReplaceImg = async (auth: Auth, imageUrl?: string) => {
	if (auth.currentUser) {
		const { uid, photoURL } = auth.currentUser;
		if (photoURL || imageUrl) {
			await setImage(uid, imageUrl || (photoURL as string));
			return getCdnLink(uid);
		}
	}
	return null;
};

const setImage = async (uid: string, photoURL: string) => {
	const storage = getStorage(app);
	const storageRef = ref(storage, `profile_images/${uid}/profile.jpg`);
	const base64Img = await getBase64Img(photoURL);
	
	// Upload string and get snapshot
	const response = await uploadString(storageRef, base64Img, "data_url", {
		contentType: "image/jpg",
	});
	
	return response;
};

export const getCdnLink = (uid: string) => `https://media.online.brushfire.com/profile_images/${uid}/profile.jpg`;

const getBase64Img = (url: string) => {
	return new Promise<string>(async (resolve, reject) => {
		try {
			const response = await axios({
				method: "get",
				url: url,
				responseType: "blob",
			});
			
			if (response && response.data) {
				const reader = new FileReader();
				reader.readAsDataURL(response.data);
				reader.onloadend = () => {
					const base64data = reader.result as string;
					resolve(base64data);
				};
			} else {
				reject("");
			}
		} catch (e) {
			console.log(">>>> e, ", JSON.stringify(e));
			reject("");
		}
	});
};

export default setOrReplaceImg;
